import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProjectDetailEndpoint } from './project-detail-endpoint';

@Injectable({
  providedIn: 'root',
})
export class ProjectDetailRoutingResolver
  
{
  constructor(private http: HttpClient, private router: Router) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    return this.http.get(route.data.dataUrl).pipe(
      catchError((err) => {
        console.error(err);
        this.router.navigate(['/']);
        return EMPTY;
      })
    );
  }
}
